<template>
  <div class="container-fluid autenticacao">
    <div class="card autenticacao-card autenticacao-card--wide">
      <div class="card-header">
        <div class="card-header-content">
          <div class="card-title-group">
            <div class="card-icon-badge">
              <i class="pi pi-users"></i>
            </div>
            <div>
              <h5 class="panel-title">Listagem de Contribuintes</h5>
              <p class="panel-subtitle">Consulte os prestadores e contribuintes cadastrados no município</p>
            </div>
          </div>
        </div>
      </div>
      <div id="topo" class="card-body">
        <!-- Barra de Filtros Moderna -->
        <div class="filter-bar-modern">
          <div class="filter-bar-row">
            <div class="filter-bar-item">
              <label for="tipoConsulta" class="form-label-modern">Tipo Consulta:</label>
              <Dropdown
                id="tipoConsulta"
                name="tipoConsulta"
                v-model="selectedTipoConsulta"
                :options="tiposConsulta"
                optionLabel="name"
                placeholder="Tipo Consulta"
                class="dropdown-modern"
              />
            </div>
            <div class="filter-bar-item">
              <label for="tipoSelecao" class="form-label-modern">Tipo Seleção:</label>
              <Dropdown
                id="tipoSelecao"
                name="tipoSelecao"
                v-model="selectedTipoSelecao"
                :options="tiposSelecao"
                optionLabel="name"
                placeholder="Tipo Seleção"
                class="dropdown-modern"
              />
            </div>
            <div class="filter-bar-item filter-bar-item--grow">
              <label for="filtro" class="form-label-modern">Termo de Pesquisa:</label>
              <InputText
                id="filtro"
                v-model="filtro"
                placeholder="Digite o termo para pesquisar..."
                @keyup.enter="pesquisar"
                class="input-modern"
              />
            </div>
            <div class="filter-bar-item filter-bar-item--button">
              <Button
                @click="pesquisar()"
                label="Pesquisar"
                type="button"
                class="btn-modern-primary"
                icon="pi pi-search"
                :disabled="loading"
              />
            </div>
          </div>
        </div>

        <!-- Tabela de Contribuintes -->
        <div class="table-responsive-wrapper">
          <DataTable
            :value="usuarioList"
            :paginator="true"
            :rows="10"
            :scrollable="false"
            :autoLayout="true"
            :loading="loading"
            class="p-datatable-responsive"
          >
            <template #empty>
              <div class="text-center p-4" style="color: #64748b; font-size: 14px;">
                <i class="pi pi-info-circle mr-2"></i>
                Nenhum contribuinte encontrado.
              </div>
            </template>
            <Column header="Documento" headerStyle="width: 14em">
              <template #body="slotProps">
                <span class="p-column-title">Documento</span>
                {{ slotProps.data.documento }}
              </template>
            </Column>
            <Column header="Nome / Razão Social">
              <template #body="slotProps">
                <span class="p-column-title">Nome</span>
                {{ slotProps.data.nome }}
              </template>
            </Column>
            <Column header="Inscrição Municipal" headerStyle="width: 14em">
              <template #body="slotProps">
                <span class="p-column-title">Inscrição Municipal</span>
                {{ slotProps.data.inscricaoMunicipal }}
              </template>
            </Column>
          </DataTable>
        </div>

        <!-- Ações do Rodapé -->
        <div class="form-actions-modern">
          <Button
            label="Voltar ao Login"
            type="button"
            class="btn-modern-secondary"
            icon="pi pi-arrow-left"
            @click="login()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SolicitacaoCadastroService from "../services/tributario/solicitacao.cadastro.service";
import DnsClienteService from "../services/nfse/dns.cliente.service";

export default {
  name: "selecaoEmpresa",
  data() {
    return {
      loading: false,
      search: false,
      filters: {},
      filtro: null,
      tiposConsulta: [],
      tiposSelecao: [],
      selectedTipoConsulta: null,
      selectedTipoSelecao: null,
      usuarioList: [],
      idCliente: null
    };
  },
  created() {
    try {
      const raw = localStorage.getItem('nfse_login_cache') || sessionStorage.getItem('nfse_login_cache');
      if (raw) {
        const cached = JSON.parse(raw);
        if (cached) {
          this.idCliente = cached.idCliente || null;
        }
      }
    } catch (e) {
      console.warn(e);
    }

    this.filtro = "";
    this.selectedTipoConsulta = { name: "CPF/CNPJ", key: "D" };
    this.selectedTipoSelecao = { name: "Emissores de NFS-e", key: "C" };
    this.tiposConsulta = [
      { name: "CPF/CNPJ", key: "D" },
      { name: "Nome Contribuinte", key: "N" },
      { name: "Inscrição Municipal", key: "I" }
    ];
    this.tiposSelecao = [
      { name: "Emissores de NFS-e", key: "C" },
      { name: "TODOS", key: "T" }
    ];
  },
  mounted() {
    if (this.idCliente) {
      this.pesquisar();
    }
    let host = window.location.hostname;
    DnsClienteService.get(host).then((dns) => {
      if (dns && dns.data && dns.data.idCliente) {
        const novoId = dns.data.idCliente;
        if (!this.idCliente) {
          this.idCliente = novoId;
          this.pesquisar();
        }
      }
    });
  },
  methods: {
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    },
    pesquisar() {
      this.processando(true);
      this.search = true;

      SolicitacaoCadastroService.findAllContrFiltro(
        this.idCliente,
        this.filtro,
        this.selectedTipoConsulta.key,
        this.selectedTipoSelecao.key
      )
        .then((ua) => {
          this.usuarioList = ua.data;
        })
        .catch((error) => {
          console.error(error);
          this.$root.$emit("alert:warn", "Não foi possível carregar os contribuintes.");
        })
        .finally(() => {
          this.processando(false);
          this.search = false;
        });
    },
    login() {
      this.$router.push("/login");
    },
  }
};
</script>

<style src="../assets/css/links-autenticacao-recibo-credenciamento-contribuintes.css"></style>
